import { render, staticRenderFns } from "./EmailOpportunityOfferDeliverance.vue?vue&type=template&id=43ed17b2&scoped=true&lang=pug&"
import script from "./EmailOpportunityOfferDeliverance.vue?vue&type=script&lang=js&"
export * from "./EmailOpportunityOfferDeliverance.vue?vue&type=script&lang=js&"
import style0 from "./EmailOpportunityOfferDeliverance.vue?vue&type=style&index=0&id=43ed17b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ed17b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VCol,VDivider,VForm,VIcon,VRadio,VRadioGroup,VRow,VTextField})
